<app-list-cached-entity-instances-comp #listComp>

</app-list-cached-entity-instances-comp>
